module.exports = __webpack_public_path__ + "static/img/banner5.5daf79d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepageComponent/images/banner5.jpg
// module id = 75vI
// module chunks = 6